import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import update from "immutability-helper";

const ItemType = "DRAGGABLE_ITEM";

const DraggableItem = ({ id, index, moveItem, render, data }) => {
  const ref = useRef(null);
  const isFixed = index === 0;

  const [, drop] = useDrop({
    accept: ItemType,
    canDrop: () => !isFixed, // ❌ prevent drop on first item
    hover(item) {
      if (!ref.current || item.index === index || isFixed) return;
      moveItem(item.index, index);
      item.index = index;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { id, index },
    canDrag: !isFixed, // ❌ prevent dragging the first item
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Apply drag & drop only if not fixed
  if (!isFixed) drag(drop(ref));

  return (
    <div
      ref={ref}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: isFixed ? "default" : "move",
      }}
    >
      {render(data, index)}
    </div>
  );
};

const DraggableList = ({ items, onChange, renderItem }) => {
  const moveItem = (fromIndex, toIndex) => {
    const updated = update(items, {
      $splice: [
        [fromIndex, 1],
        [toIndex, 0, items[fromIndex]],
      ],
    });
    onChange(
      updated?.map((d, i) => ({
        ...d,
        permissions: items?.find((d) => d?.position === i + 1)?.permissions,
        position: i + 1,
      }))
    );
  };

  return (
    <>
      {items?.map((item, index) => (
        <DraggableItem
          key={item.id || index}
          id={item.id || index}
          index={index}
          data={item}
          moveItem={moveItem}
          render={renderItem}
        />
      ))}
    </>
  );
};

export default DraggableList;
